import { useEffect } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { useAppSelector } from 'store';
import { selectUser } from 'store/selectors/me/user';
import config from 'utils/config';

let analytics: ReturnType<typeof AnalyticsBrowser.load> | null = null;
let identifiedUserId: string | null = null; // Track who we've identified

const allowSegment = config.isProduction || sessionStorage.getItem('allow-segment') === 'true';

export const initSegment = () => {
  if (!allowSegment) return null;
  if (!analytics && config.segment.writeKey) {
    analytics = AnalyticsBrowser.load({ writeKey: config.segment.writeKey });
  }
  return analytics;
};

export const identifyUser = (user: any) => {
  if (!allowSegment) return;
  if (!analytics || !user || user.flags?.stayAnonymous) return;

  if (identifiedUserId !== user._id) {
    analytics.identify(user._id, {
      name: `${user.firstName} ${user.lastName}`,
      email: user.emails?.[0]?.address,
    });
    identifiedUserId = user._id;
  }
};

const useSegment = () => {
  const user = useAppSelector(selectUser);

  useEffect(() => {
    const initializedAnalytics = initSegment();
    if (initializedAnalytics && user) {
      identifyUser(user);
    }
  }, [user]);

  return initSegment();
};

export default useSegment;
